import { Link } from "react-router-dom";
import {
  AddIcon,
  DeleteIcon2,
  EditIcon,
  LoadingIcon,
  SearchIcon,
} from "../../components/SVG";
import { editDineInService, getDineInService } from "../../service";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Snackbar from "../../components/Snackbar";

const DineInPage = () => {
  const [list, setList] = useState([]);
  const [pageLoader, setPageLoader] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const [confirmModal, setConfirmModal] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [snackbar, setSnackbar] = useState({ show: false, message: "" });

  const limit = 10;

  const getEvents = () => {
    let query = `?limit=${limit}&page=${page}&search=${search}`;
    setPageLoader(true);
    getDineInService(query).then((res) => {
      setPageLoader(false);
      if (res.status == 200) {
        setList(res.data.responseData);
      }
    });
  };

  useEffect(() => {
    getEvents();
  }, [search, page]);

  const handleClose = () => {
    setConfirmModal(false);
    setActiveId("");
  };

  const handleConfirm = () => {
    // Find and store the item to be deleted
    const itemToDelete = list.find((item) => item.id === activeId);

    // Optimistically remove from the list
    setList((prevList) => prevList.filter((item) => item.id !== activeId));
    handleClose();

    // Call API in background
    let params = { status: 3 };
    let query = `/${activeId}`;
    editDineInService(query, params)
      .then((res) => {
        if (res.status !== 200) {
          // Restore the item if deletion failed
          if (itemToDelete) {
            setList((prevList) => [...prevList, itemToDelete]);
          }
          setSnackbar({
            show: true,
            message: "The deletion failed. Please try again.",
          });
        }
      })
      .catch((err) => {
        // Restore the item on error
        if (itemToDelete) {
          setList((prevList) => [...prevList, itemToDelete]);
        }
        setSnackbar({
          show: true,
          message: "The deletion failed. Please try again.",
        });
      });
  };

  const handleStatusChange = (item) => {
    let params = { status: item.status == 1 ? 2 : 1 };
    let query = `/${item.id}`;
    editDineInService(query, params).then((res) => {
      if (res.status == 200) {
        getEvents();
      }
    });
  };

  return (
    <div className="page_wrapper px-4 py-5">
      <div className="page_top_actions">
        <div>
          <Link className="btn btn-primary px-4" to="/dinein/create">
            <AddIcon /> Add Private Dining
          </Link>
        </div>
        <div>
          <div className="cm_search">
            <SearchIcon />
            <input
              value={search}
              onChange={(e) => (setSearch(e.target.value), setPage(1))}
              placeholder="Search"
              type="text"
              className="form-control"
            />
          </div>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Sorting Order</th>
              <th>Name</th>
              <th>Email</th>
              <th>Manager Name</th>
              <th className="sticky-action-col">CTA</th>
            </tr>
          </thead>

          {pageLoader ? (
            <tbody>
              <tr>
                <td colSpan={5} className="text-center">
                  <LoadingIcon />
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {list.map((item, i) => (
                <tr key={i}>
                  <td className="text-center bg_light_pink">
                    <b>{item.sorting_order || "-"}</b>
                  </td>
                  <td>
                    <img className="event_img_sm" src={item.img_url} />{" "}
                    <b className="ms-3">{item.name}</b>
                  </td>
                  <td>{item.email}</td>
                  <td>{item.manager_name}</td>
                  <td className="sticky-action-col">
                    <Link
                      to={`/dinein/update/${item.id}`}
                      className="table_action_icon"
                    >
                      <EditIcon />
                    </Link>
                    <span
                      onClick={() => (
                        setActiveId(item.id), setConfirmModal(true)
                      )}
                      title="Delete"
                      className="table_action_icon ms-3"
                    >
                      <DeleteIcon2 />
                    </span>
                    <span className="cm_check_box">
                      <input
                        checked={item.status == 1}
                        onChange={() => handleStatusChange(item)}
                        type="checkbox"
                      />
                      <span />
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>

      <Modal show={confirmModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this Private Dining?
        </Modal.Body>
        <Modal.Footer>
          <span className="btn btn-secondary px-5" onClick={handleClose}>
            No
          </span>
          <span className="btn btn-primary px-5" onClick={handleConfirm}>
            Yes
          </span>
        </Modal.Footer>
      </Modal>

      <Snackbar
        show={snackbar.show}
        message={snackbar.message}
        onClose={() => setSnackbar({ show: false, message: "" })}
        type="error"
      />
    </div>
  );
};

export default DineInPage;
